<template>
  <!-- https://michalsnik.github.io/aos/ -->
  <v-container>

        <v-card
      class="mx-auto"
      max-width="550"
    >


      <v-card  color="grey lighten-5"  dark>


  <div>
          <v-sheet color="white" class="ma-0 pa-4" height="100%" max-height=300 min-height=120 tile>
            <v-row class="fill-height"  align="center" justify="center">
            
              <div class="ma-0 pa-4 text-center">


                <div class="ma-0 pa-0 text-h4 cGrey--text text-centre" >Welcome to Microcise
                </div> 
                <div class="ma-0 pa-0 text-h6 cGrey--text text-centre" >stretch, move and
strengthen exercises at your desk
                </div>               

              </div>
            </v-row>
          </v-sheet>

          <v-sheet class="ma-0 pa-4" color="grey darken-1" height="100%"  max-height=530 min-height=130 tile>
            <v-row  align="center" justify="left">
              <v-col  cols="2" align="right" justify="right"> <v-chip class="ma-2" color="primary"  text-color="white">1</v-chip></v-col>
              <v-col  cols="10">
                <div class="ma-0 pa-0" align="left"
      justify="center">
                    Sign into Microcise. Click the bell icon at the bottom of this page to subscribe to System notifications <span class="text-caption"> (Click again to unsubscribe)</span>
                   
                </div>
              </v-col>
            </v-row>
   
            <v-row  align="center" justify="left">
              <v-col  cols="2" align="right" justify="right"></v-col>
              <v-col  cols="10">
                <div class="ma-0 pa-0" align="center"
      justify="center">
            
                    <v-img max-height="40"  max-width="40" position="center center" src="/icons/bell_prompt.png"></v-img>
                </div>
              </v-col>
            </v-row>
            <v-row  align="center" justify="left">
              <v-col  cols="2" align="right" justify="right"> <v-chip class="ma-2" color="primary"  text-color="white">2</v-chip></v-col>
              <v-col  cols="10">
                <div class="ma-0 pa-0">
                    You will receive regular notifications throughout the day with links to preset exercises
                </div>
              </v-col>
            </v-row>
            <v-row  align="center" justify="left">
              <v-col  cols="2" align="right" justify="right"> <v-chip class="ma-2" color="primary"  text-color="white">3</v-chip></v-col>
              <v-col  cols="10">
                <div class="ma-0 pa-0">
                    Run ad hoc  session at anytime. Use premade sessions, or create your own.
                </div>
              </v-col>
            </v-row>
                     
          </v-sheet>


          <v-sheet class="ma-0 pa-4" color="white cGrey--text" height="100%"  max-height=300 min-height=300 tile>
             <v-row align="center" justify="center" class="mt-2">

                <div class="text-h5">

                  <v-card-text>            
                  <p align="center" justify="center" class="ma-0 pa-0 text-h6">Notification Schedule (Monday-Friday)</p>
                  <p align="center" justify="center" class="ma-0 pa-0 text-body-1">08:00 - Early Morning Stretch</p>
                  <p align="center" justify="center" class="ma-0 pa-0 text-body-1">09:00 - Start of the Day Stretch</p>
                  <p align="center" justify="center" class="ma-0 pa-0 text-body-1">10:00 - Morning Moves!</p>
                  <p align="center" justify="center" class="ma-0 pa-0 text-body-1">11:00 - A Mid Morning Stretch</p>
                  <p align="center" justify="center" class="ma-0 pa-0 text-body-1">12:00 - Power Move</p>
                  <p align="center" justify="center" class="ma-0 pa-0 text-body-1">14:00 - Strengthen!</p>       
                  <p align="center" justify="center" class="ma-0 pa-0 text-body-1">15:00 - Afternoon Movement</p>
                  <p align="center" justify="center" class="ma-0 pa-0 text-body-1">16:00 - Afternoon Stretch</p>
                  <p align="center" justify="center" class="ma-0 pa-0 text-body-1">17:00 - Power Move</p>
                                                     
                    </v-card-text>
                </div> 
          
              </v-row>
          </v-sheet>          

    </div>



    <!-- BUTTONS -->
    <v-sheet color="white" height="100%"  max-height=120 min-height=120 tile>
    <v-row>
        <v-col  cols="12">
          <div>   

            <div class="text-center">
                  <v-btn width="250" class="ma-2 pa-0 text-center" rounded dark  color="pink darken-2" @click="$router.push('/auth?action=signIn')">Sign in
              </v-btn>
            </div>
 
          </div>
      </v-col>
  </v-row>
</v-sheet>
    </v-card>    

  </v-card>


  </v-container>
</template>

<style>
.v-progress-circular {
margin: 1rem;
}
</style>



<script>
export default {

  name: 'Home',

  data: () => ({
    progressOpacity:0.1,

    group: null,
    signedIn:false,
    totalForToday: 0,
    currentJWT: "",
    userDetails:null,    

colors: [
        'primary',
        'secondary',
        'yellow darken-2',
        'red',
        'orange',
      ],
      model: 0,

  }),
  created() {
   
  },  
  async mounted() {
    

    },
   computed: {

// https://vuetifyjs.com/en/features/breakpoints/#breakpoint-service
//https://vuetifyjs.com/en/styles/text-and-typography/#typography
 titleFontSize () {
    
        switch (this.$vuetify.breakpoint.name) {
          case 'xs': return 'h6'
          case 'sm': return 'h5'
          case 'md': return 'h4'
          case 'lg': return 'h3'
          case 'xl': return 'h2'
          default: return 'h3'
        }
      },
  subTitleFontSize () {
       
        switch (this.$vuetify.breakpoint.name) {
          case 'xs': return 'h6'
          case 'sm': return 'h6'
          case 'md': return 'h5'
          case 'lg': return 'h4'
          case 'xl': return 'h4'
          default: return 'h3'
        }
      }, 
  
  subSubTitleFontSize () {
       
        switch (this.$vuetify.breakpoint.name) {
          case 'xs': return 'subtitle-1'
          case 'sm': return 'subtitle-1'
          case 'md': return 'h5'
          case 'lg': return 'h5'
          case 'xl': return 'h4'
          default: return 'h4'
        }
      }, 


  copyFontSize () {
       
        switch (this.$vuetify.breakpoint.name) {
          case 'xs': return 'subtitle-1'
          case 'sm': return 'subtitle-1'
          case 'md': return 'h6'
          case 'lg': return 'h5'
          case 'xl': return 'h5'
          default: return 'h6'
        }               
      },

    },  
  methods: {




  }          
}
</script>


<style>
a {
  color: grey !important;
}


.max-width-chip.v-chip {
  max-width: 70px;
  min-width: 70px;
}


.max-width-chip .v-chip__content {
  line-height: 32px;
  display: inline-block !important;
  white-space: nowrap;
  overflow: hidden;
   text-overflow: ellipsis;
  position: relative;
}

</style>
